/**
 * @file JobSearchEmptySlot.tsx
 *
 * @fileoverview Renders job detail instructions if none job is selected.
 */

import React from 'react';
import Image from '~/jobiqo/components/Image';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import styles from './jobSearchEmptyCustom.module.scss';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import RichFormattedMessage from '~/jobiqo/components/RichFormattedMessage';

interface JobSearchEmptySlotProps {
  /**
   * The count of jobs.
   */
  totalCount?: Slottable<number>;
}

export const JobSearchEmptySlot = ({}: JobSearchEmptySlotProps) => {
  return (
    <div className={styles.emptySearchWrapper}>
      <Image
        alt={'Job search Image'}
        src={'/static/images/job-search.svg'}
        width={800}
        height={800}
      />
      <Spacing />
      <div>
        <RichFormattedMessage
          id="job_detail_panel_instructions"
          defaultMessage="To see all the details of a job posting please choose one from the list on the left."
        />
      </div>
    </div>
  );
};
export default JobSearchEmptySlot;
